export type Environment = {
  name: string;
  production: boolean;
  remoteApi: string;
  sentryDsn?: string;
  sentryEnvironment?: string;
};
